import { useEffect, useState } from 'react';
import globalUseStyles from '../../../../styles/globalCustomStyles';
import useQueryProvider from '../../../aegeon/query/useQueryProvider';

import { Card, Typography } from '@mui/material';
import { useGetList, useRecordContext, useTranslate } from 'react-admin';
import InfoTooltipIcon from '../../../../assets/InfoTooltipIcon';
import { anonymize, empty_list_if_demo } from '../../../../utils/anonymize';
import CustomTable from '../../../Table/CustomTable';
import CustomTooltip from '../../../aegeon/CustomTooltip';
import ChartLoading from '../../../aegeon/charts/ChartLoading';
import { convert_array_to_string, filter_and_sort_devices } from '../../../aegeon/helper';
import DeviceTypeIcon from '../../../devices/CustomComponents/DeviceTypeIcon';

const SiteCompositionDetailsContentDevices = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();

  const record = useRecordContext();
  const siteId = record?.id;
  const [deviceContracts, setDeviceContracts] = useState({});
  const [devicesData, setDevicesData] = useState(null);
  const [devicesFiltered, setDevicesFiltered] = useState([]);

  const { data, isLoading } = useGetList(
    'devices',
    {
      filter: {
        siteIds: { contains: siteId },
      },
    }
  );

  const devices_contracts_ids = data?.filter(device => device?.deviceType === "enedisMeter" || device?.deviceType === "grdfMeter")?.map(device => device?.id);

  useEffect(() => {
    if (data && devices_contracts_ids?.length > 0 && (Object.keys(deviceContracts)?.length === devices_contracts_ids?.length) && !devicesData) {
      setDevicesData(data.map(device => {
        if (device?.deviceType === "enedisMeter" || device?.deviceType === "grdfMeter") {
          return { ...device, contract: deviceContracts[device?.id] || "" };
        }
        return device;
      }));
    }
  }, [data, devices_contracts_ids, deviceContracts, devicesData]);

  useEffect(() => {
    if (data) {
      let devices_filtered = filter_and_sort_devices(data);
      if (deviceContracts) {
        devices_filtered = devices_filtered.map(device => ({
          ...device,
          contract: deviceContracts[device.id] ? deviceContracts[device.id] : ""
        }));
      }
      setDevicesFiltered(devices_filtered);
    }
  }, [data, devicesData]);


  if (isLoading === true) {
    return (
      <ChartLoading />
    );
  }

  const DeviceContractsFetcher = ({ deviceId, onContractsFetched, deviceContracts }) => {
    const { data, isLoading } = useQueryProvider('devices', {
      query_name: "getDeviceContract",
      id: deviceId,
    });

    useEffect(() => {
      if (!isLoading && onContractsFetched && !deviceContracts[deviceId]) {
        if (data?.donneesGenerales?.etatContractuel?.libelle) {
          onContractsFetched(data?.donneesGenerales?.etatContractuel?.libelle);
        }
        else if (data?.permissions?.etat_droit_acces) {
          onContractsFetched(data?.permissions?.etat_droit_acces);
        }
        else {
          onContractsFetched("");
        }
      }
    }, [data, isLoading, onContractsFetched]);

    return null;
  };

  const rows = [{ name: t('sites.composition.device_code'), values: [t('sites.composition.device_state'), t('sites.composition.device_destination'), t('sites.composition.device_quality'), t('sites.composition.device_usage'), t("sites.composition.device_tenants"), t("sites.composition.device_tenth"), ''] }]
  devicesFiltered.forEach((device) => {
    let destination = device.airtable?.destination ? device.airtable?.destination : "inconnue";
    let quality = device.fusionedEnergyQuality ? device.fusionedEnergyQuality : "";
    let usage = device.airtable?.usage ? convert_array_to_string(device.airtable?.usage) : "";
    let tenants = empty_list_if_demo(device.airtable?.functional_entities ? device.airtable?.functional_entities.map(ef => ef.tenant_name) : []);
    let state = (device?.contract ? device?.contract : "") + (device?.airtable?.deposited ? " Déposé" : '');

    let site_tenth = device.airtable?.building_tenths?.find(tenth => tenth.site_code === record?.airtable?.code)?.tenth;

    // Drop null values in tenants
    tenants = tenants.filter((tenant) => tenant);
    tenants = [...new Set(tenants)].join(', ');
    rows.push({
      name: anonymize(device.name),
      icon: <DeviceTypeIcon deviceType={device.deviceType} />,
      icon_tooltip: t("devices.deviceTypes." + device.deviceType),
      values: [state, destination, quality, usage, tenants, site_tenth, ''],
      path: "/devices/" + device.id + "/show",
      tooltip_link: "sites.composition.device_tooltip_link"
    })
  })

  return (
    <Card className={globalClasses.DetailCard}>
      {(deviceContracts?.length !== devices_contracts_ids?.length) &&
        devices_contracts_ids?.map((id, index) => (
          <DeviceContractsFetcher
            deviceContracts={deviceContracts}
            deviceId={id}
            key={index}
            onContractsFetched={(contract) => {
              if (!Object.keys(deviceContracts).includes(id)) {
                setDeviceContracts((prevContracts) => ({ ...prevContracts, [id]: contract }));
              }
            }}
          />
        ))
      }
      <div className={globalClasses.DetailCardTableTitle}>
        <Typography display="block" variant="h8">{t('sites.composition.devices_title') + " (" + devicesFiltered.length + ")"}</Typography>
        <CustomTooltip title={t('sites.composition.devices_tooltip')} icon={<InfoTooltipIcon />} />
      </div>
      <div className={globalClasses.DetailCardTableSubtitle} />
      <CustomTable list={true} rows={rows} defaultTooltip={"sites.no_data_tooltip"} />
    </Card>
  );
};

export default SiteCompositionDetailsContentDevices;